// NavBar.js
import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";
import navLinks from "./NavBarData";
import "./NavBar.css";
import { ArrowDropDown } from "@mui/icons-material";
import Marquee from "../hooks/marquee";

const MenuLinks = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 1) {
      setVisible(true);
    } else if (scrolled <= 1) {
      setVisible(false);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const TitleLink = ({ link }) => {
    return (
      <div style={{ display: "flex" }}>
        {link}{" "}
        <div style={{ marginTop: "0.2rem" }}>
          <ArrowDropDown />
        </div>
      </div>
    );
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour 
      in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <nav className="navbar">
      <div className="logoDisplayMinimized">
        <Link to="/">
          <img src="aboutus/mobileheader.png" alt="Curd Africa" />
        </Link>
      </div>
      <div className="menu-icon" onClick={toggleMenu}>
        <FaBars />
      </div>
      <div className="nav-title">
        <div
          className="marqueeWrapper"
          style={{ display: visible ? "none" : "inline" }}
        >
          <Marquee
            text="Governance and Democracy, Economic empowerment and Climate Change,
 Social Justice, Inclusion and Child Protection,HIV/AIDS and Drug and
drug abuse,Resource Center/ Medical Clinic, Institutional Capacity
Strengthening"
          ></Marquee>
        </div>
        <img
          src="/aboutus/minilogo.png"
          alt="Curd Africa"
          style={{ display: visible ? "inline" : "none" }}
        />
        <h5 style={{ display: visible ? "inline" : "none" }}>
          COMMUNITY UNITED FOR RURAL DEVELOPMENT
        </h5>
        
      </div>
      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        {navLinks.map((link, index) => (
          <li key={index} onMouseLeave={closeMenu}>
            <Link onClick={scrollToTop} to={link.path}>
              {link.subLinks ? <TitleLink link={link.title} /> : link.title}
            </Link>
            {link.subLinks && (
              <ul className="sub-links">
                {link.subLinks.map((subLink, subIndex) => (
                  <li key={subIndex}>
                    <Link
                      to={`/${subLink.toLowerCase()}`}
                    >
                      {subLink}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MenuLinks;
